const en_US = {
  nav_api: "API Docs",
  nav_manageApp: "Manage Apps",
  nav_signin: "Sign In",
  nav_signup: "Sign Up",
  manageApp_title: "Manage Apps",
  manageApp_newApp: "App Name",
  manageApp_appName: "Name",
  manageApp_desctiption: "Description",
  manageApp_action: "Actions",
  manageApp_edit: "Edit",
  manageApp_delete: "Delete",
  manageApp_signInTip: "Please {signin} before you try to manage the applications.",
  manageApp_signInTip_signin: "sign in",
  manageApp_noAppTip: `No applications yet. Please click the "New App" button at the top right corner to add a new one. `,
  deleteApp_title: "Delete Application",
  deleteApp_content: "Deleting cannot be undone. Are you sure to delete this application?",
  deleteApp_delete: "Delete",
  newApp_title: "New App",
  newApp_add: "Add",
  newApp_appName: "Name",
  newApp_desctiption: "Description",
  newApp_appServicesURL: "App Service URL",
  input_placeholder: "Please enter",
  input_copy: "Copy",
  tip_appNamerequired: "Please enter your App name",
  tip_appNameMax64: "Maximum of 64 characters for the application name",
  tip_appServicesURLMax64: "Maximum of 64 characters for the app service URL",
  tip_redirectURLMax64: "Maximum of 64 characters for the OAuth redirect URL",
  tip_URL: "Please enter right url",
  tip_descriptionMax1000: "Maximum of 1000 characters for the description",
  message_upload300x300: "Only 300px x 300px size for Application Icon can be uploaded",
  message_uploadType: "You can only upload JPG/PNG file!",
  message_uploadSize: "File must smaller than 2MB!",
  message_copied: "Copied",
  message_createFailed: "Add failed",
  message_deleteFailed: "Delete failed",
  message_saveFailed: "Save failed",
  message_resetFailed: "Reset failed",
  appSetting_title: "App Setting",
  appSetting_description:
    "We adopt the OAuth 2.0 protocol, which allows your app to request for authorization of your TickTick data directly without a password.",
  appSetting_reset: "Reset",
  button_cancel: "Cancel",
  button_reset: "Reset",
  reset_title: "Are you sure reset your client secret?",
  reset_content: "The reset operation can't undo",
  appSetting_appName: "Name",
  appSetting_desctiption: "Description",
  appSetting_appServicesURL: "App Service URL",
  appSetting_appIcon: "App Icon",
  appSetting_save: "Save",
  appSetting_back: "Back",
  appSetting_upload: "Upload"
};
export default en_US;
